module.exports = __webpack_public_path__ + "static/media/oro-orb-video-still.ed61ab12.png";